import React from 'react';

import { Point2D } from '@paragon/contract-library';

import { CanvasPolygons } from './CanvasPolygons';

interface Props {
  readonly memberVertices: readonly (readonly Point2D[])[];
  readonly url?: string;
  readonly maxWidth: number;
  readonly maxHeight: number;
  readonly sx?: React.CSSProperties;
}

export function ComponentPreview({ memberVertices, url, maxWidth, maxHeight, sx }: Props) {
  function onClickCanvas() {
    if (url) window.open(url, '_blank');
  }

  return (
    <CanvasPolygons
      shapes={memberVertices}
      sx={{ cursor: url ? 'pointer' : 'auto', ...sx }}
      onClick={onClickCanvas}
      color="orange"
      maxWidth={maxWidth}
      maxHeight={maxHeight}
    />
  );
}
